import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StudentCounsellingDetailsLinkComponent } from './student-counselling-details-link/student-counselling-details-link.component';
import { StudentCounsellingDetailsComponent } from './student-counselling-details/student-counselling-details.component';

const routes: Routes = [
  {
                  path:'',component:StudentCounsellingDetailsLinkComponent,
                  children:[
                    {
                      path:"studentCounsellingdetailesReport", component:StudentCounsellingDetailsComponent
                    },  
                  ]
                }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentCounsellingDetialsReportRoutingModule { }
